<template>
  <div class="w-full">
    <Accordion :activeIndex="0" class="w-8 mx-auto">
      <AccordionTab v-for="item in items" :header="item?.[group_by ?? 'name']">
        <WebComponent :item="item" />
      </AccordionTab>
    </Accordion>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Object,
    required: true
  },
  group_by: {
    type: String
  }
})
</script>
